import { fileArchive } from '@/mocks/exposure';
import { SectionHead, Tag } from './ui';

const extColor: Record<string, string> = {
  PDF: 'text-primary-600 bg-primary-50 border-primary-200',
  XLS: 'text-accent-700 bg-accent-50 border-accent-200',
  DOC: 'text-secondary-700 bg-secondary-100 border-secondary-200',
  ZIP: 'text-foreground-600 bg-background-100 border-background-200',
};

export default function FileSection() {
  return (
    <div className="bg-background-100">
      <section
        id="file"
        className="mx-auto grid w-full max-w-[1280px] items-start gap-6 px-4 py-9 md:px-6 md:py-14 lg:grid-cols-3"
      >
        <div className="rounded-xl border border-foreground-900 bg-foreground-900 p-5 text-background-100 lg:col-span-1 md:p-6">
          <Tag tone="accent">一手文件材料</Tag>
          <h2 className="mt-4 font-serif text-xl font-black leading-snug md:text-2xl">
            合同 · 流水 · 公告，逐件可核对的原始材料
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-background-300">
            脱敏后归档，关键数字与日期保留可检索，供与公开口径逐项比对复核，杜绝只凭截图下结论。
          </p>
          <div className="mt-5 flex flex-wrap gap-2 text-[11px] text-background-200">
            {['合同扫描', '流水表', '回应函', '送审目录'].map((t) => (
              <span key={t} className="rounded-full border border-background-100/25 px-2.5 py-1">
                {t}
              </span>
            ))}
          </div>
        </div>

        <div className="rounded-xl border border-background-200 bg-background-50 lg:col-span-2">
          <div className="flex items-center justify-between border-b border-background-200 px-4 py-3 md:px-5">
            <span className="text-sm font-bold text-foreground-800">最新文件</span>
            <span className="inline-flex items-center gap-1.5 text-xs text-foreground-400">
              <i className="ri-secure-payment-line text-primary-500" /> 已脱敏 · 共 351 件
            </span>
          </div>
          <ul className="divide-y divide-background-100">
            {fileArchive.map((f, i) => (
              <li key={i}>
                <a href="#" className="group flex items-center gap-3 px-4 py-3 transition hover:bg-background-100/70 md:px-5">
                  <span
                    className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md border text-[10px] font-black ${extColor[f.ext]}`}
                  >
                    {f.ext}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="line-clamp-1 block text-sm font-medium text-foreground-800 group-hover:text-primary-700">
                      {f.title}
                    </span>
                    <span className="mt-1 flex items-center gap-2 text-[11px] text-foreground-400">
                      <Tag tone="secondary">{f.tag}</Tag>
                      <span className="whitespace-nowrap">{f.time} 上传</span>
                    </span>
                  </span>
                  <span className="hidden shrink-0 items-center gap-2 text-xs text-foreground-500 sm:flex">
                    {f.size}
                    <i className="ri-download-2-line text-base text-foreground-400 group-hover:text-primary-500" />
                  </span>
                </a>
              </li>
            ))}
          </ul>
          <div className="flex justify-center border-t border-background-100 py-3">
            <button className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-background-200 px-4 py-2 text-xs font-medium text-foreground-600 transition hover:border-primary-300 hover:text-primary-600">
              浏览完整文件库 <i className="ri-folder-shared-line" />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}